
import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { ColumnModel, GridRequestReferenceModel, GridModel, DefGroupsModel } from '../../api/api.models'
import { EventsNames } from '../../../helpers/events-names'
import { CommonHelper } from '../../../helpers/common-helper'
import { i18n } from '../../common/i18n/common.i18n'
import { RequestManager } from '../../../helpers/request-manager'
import { GridOptions, GridTypes } from '../grid/grid.controller'
import { Md5 } from '../../../helpers/md5-helper'
import { TemplateHelper, ConfigHelper, IUserSession } from '../../../helpers'

import './groups-edit.scss'
import * as TEMPLATE from './groups-edit.tpl.html'
import DataSource from 'devextreme/data/data_source'
import Store from 'devextreme/data/abstract_store'
import DevExpress from 'devextreme'

export interface GroupsBridge {
    id: number
    distributorId: number
    assigned: any[]
    popupId: number
    onSubmit?: (...args) => ng.IPromise<boolean>
    request?: (requestState: any) => any
    openGroup?: (e: any) => any
    onHiding: () => void
    closeEventName: string
    popupVisible: boolean
    popupTitle: string
    loadGroupsEditPopup: () => void
    activeAlarmDef?: any
    alarmDefs?: any[]
    isAlarmGroupsEdit?: boolean
    refresh?: boolean,
    meterName?: string
    submitHidden?: boolean
    allowColumnReordering?: boolean
}

export interface GroupsData {
    transferAvailableGroups(): void
    transferAssignedGroups(): void
}

export interface ChangesState {
    availableItems: any[]
    assignedItems: any[]
    assigned: any[]
    retracted: any[]
}

export interface GroupsEditScope extends ng.IScope {
    availableGroupsGridOptions: GridOptions
    assignedGroupsGridOptions: GridOptions
    availableGroupsGrid: DevExpress.ui.dxDataGrid
    assignedGroupsGrid: DevExpress.ui.dxDataGrid

    source: GroupsBridge
    popupOptions: DevExpress.ui.dxPopupOptions
    submitButtonOptions: DevExpress.ui.dxButtonOptions
    transferBackButtonOptions: DevExpress.ui.dxButtonOptions
    transferForwardButtonOptions: DevExpress.ui.dxButtonOptions
    groups: GroupsData

    assigned: any
    retracted: any
    noChanges: boolean
    oldId: number

    loadPanelMessage: string
    popupTitle: string
    activeDefAssigned: any
    transferButtonsDisabled: boolean
    isLoading: boolean

    transferBackButtonDisabled: boolean
    transferForwardButtonDisabled: boolean
}

export class GroupsEditDirective implements ng.IDirective {
    previousAvailableGroupsMd5: string
    previousAssignedGroupsMd5: string
    previousSaveRequestMd5: string
    groupsSaveFailed: boolean = false
    constructor() {

    }
    restrict = 'E'
    scope = {
        source: '='
    }
    template = TEMPLATE

    controller = ['$scope', '$q', '$timeout', 'api', 'logger', 'localDictionary', 'userSession', function ($scope: GroupsEditScope, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory, userSession: IUserSession) {
        this.$onInit = () => {
            $scope.source.loadGroupsEditPopup()
        }
        this.deferredAvailableData = $.Deferred()
        var refreshGroups = () => {
            $timeout(() => {
                var promises = []
                if ($scope.availableGroupsGrid) {
                    var availableGroupsStore = $scope.availableGroupsGrid.option('dataSource').store()
                }
                var assignedGroupsStore = $scope.assignedGroupsGrid.option('dataSource').store()
                var groups
                if ($scope.activeDefAssigned) {
                    groups = $scope.activeDefAssigned
                }
                else {
                    groups = $scope.source.assigned
                }
                groups.forEach(element => {
                    var deferred = $q.defer()
                    promises.push(deferred.promise)
                    var elementToRemove = availableGroupsStore.createQuery().filter('id', '=', element.id).toArray()[0]
                    availableGroupsStore.remove(elementToRemove).then(deferred.resolve)
                    $scope.availableGroupsGridOptions.dataSource = new DataSource({
                        store: availableGroupsStore
                    });
                    (<any>assignedGroupsStore).createQuery().filter('id', '=', element.id).toArray()[0].isRemoved = false
                })
                $q.all(promises).then(() => {
                    if ($scope.source.isAlarmGroupsEdit) {
                        if ($scope.source.activeAlarmDef) {
                            $scope.transferButtonsDisabled = false
                            var isAssigned = false
                            if ($scope.assigned && $scope.assigned[$scope.source.activeAlarmDef.id]) {
                                isAssigned = true
                                $scope.assigned[$scope.source.activeAlarmDef.id].forEach(element => {
                                    var newElement = (<any>Object).assign({}, element)
                                    newElement.isNew = true
                                    newElement.isRemoved = false
                                    assignedGroupsStore.insert(newElement);
                                    (<any>availableGroupsStore).createQuery().filter('id', '=', element.id).toArray()[0].isRemoved = true
                                })
                            }
                            if ($scope.retracted && $scope.retracted[$scope.source.activeAlarmDef.id]) {
                                isAssigned = true
                                $scope.retracted[$scope.source.activeAlarmDef.id].forEach(element => {
                                    var newElement = (<any>Object).assign({}, element)
                                    newElement.isNew = true
                                    newElement.isRemoved = false
                                    availableGroupsStore.insert(newElement);
                                    (<any>assignedGroupsStore).createQuery().filter('id', '=', element.id).toArray()[0].isRemoved = true
                                })
                            }
                            if (isAssigned) {
                                $scope.noChanges = false
                                var popupTitleNewLength = $scope.activeDefAssigned.length + $scope.assigned[$scope.source.activeAlarmDef.id].length - $scope.retracted[$scope.source.activeAlarmDef.id].length
                                $scope.source.popupTitle = $scope.popupTitle + " (" + $scope.activeDefAssigned.length + "/" + popupTitleNewLength + ")"
                                isAssigned = false
                            }
                            else {
                                if ($scope.activeDefAssigned) {
                                    $scope.source.popupTitle = $scope.popupTitle + " (" + $scope.activeDefAssigned.length + ")"
                                }
                            }
                        }
                        else {
                            $scope.source.popupTitle = $scope.popupTitle
                        }
                    }
                    else {
                        $scope.transferButtonsDisabled = false
                        $scope.source.popupTitle = $scope.popupTitle + " (" + $scope.source.assigned.length + ")"
                    }
                    $scope.isLoading = false
                    $timeout(() => {
                        $scope.availableGroupsGrid.refresh()
                        $scope.assignedGroupsGrid.refresh()
                    })
                })
            })
        }

        $scope.$watch('source.refresh', refresh => {
            if (refresh) {
                $scope.source.refresh = false
                if ($scope.availableGroupsGrid && $scope.assignedGroupsGrid)
                    stageChanges(true)
                $scope.source.popupTitle = $scope.popupTitle + " (" + $scope.source.assigned.length + ")"
            }
        })

        $scope.source.loadGroupsEditPopup = () => {
            $scope.source.onHiding = () => {
                if (this.requestState && this.requestState.request && !this.requestState.request.$resolved) {
                    isRequestCancelled = true
                    RequestManager.cancelRequest(this.requestState)
                }
                else {
                    stageChanges(true)
                }
                $scope.$root.$broadcast(EventsNames[$scope.source.closeEventName] + $scope.source.popupId)
            }
            if (!$scope.popupTitle) {
                $scope.popupTitle = $scope.source.popupTitle
            }
            if ($scope.oldId && $scope.source.id != $scope.oldId || isRequestCancelled) {
                $scope.availableGroupsGridOptions = null
                $scope.assignedGroupsGridOptions = null
                isRequestCancelled = false
            }

            if ($scope.availableGroupsGrid) {
                $scope.availableGroupsGrid.repaint()
            }
            loadGroups().then(() => {
                if (!$scope.assigned && !$scope.retracted) {
                    if ($scope.source.isAlarmGroupsEdit) {
                        $scope.assigned = {}
                        $scope.retracted = {}
                    }
                    else {
                        $scope.assigned = []
                        $scope.retracted = []
                    }
                }
                refreshGroups()
            })
            $scope.oldId = $scope.source.id
        }

        $scope.loadPanelMessage = i18n('Popup', 'Saving')

        $scope.popupOptions = {
            showTitle: true,
            showCloseButton: true,
            bindingOptions: {
                visible: 'source.popupVisible',
                title: 'source.popupTitle'
            },
            onHiding: $scope.source.onHiding,
            onShowing: () => {
                this.previousAvailableGroupsMd5 = ""
                this.previousAssignedGroupsMd5 = ""
                this.previousSaveRequestMd5 = ""
            }
        }

        var isRequestCancelled = false

        var stageChanges = (backward) => {
            $scope.isLoading = true
            var stage = () => {
                var availableDataSource = $scope.availableGroupsGrid.option("dataSource")
                var assignedDataSource = $scope.assignedGroupsGrid.option("dataSource")
                var apply = (store) => {
                    store.createQuery().filter((backward ? 'isRemoved' : 'isNew'), '=', true).toArray().forEach(element => {
                        element[(backward ? 'isRemoved' : 'isNew')] = false
                    })

                    store.createQuery().filter((backward ? 'isNew' : 'isRemoved'), '=', true).toArray().forEach(element => {
                        store.remove(element)
                    })
                }
                apply(availableDataSource.store())
                apply(assignedDataSource.store())
                if ($scope.source.isAlarmGroupsEdit) {
                    $scope.assigned = {}
                    $scope.retracted = {}
                }
                else {
                    $scope.assigned.length = 0
                    $scope.retracted.length = 0
                }
                $scope.availableGroupsGrid.refresh()
                $scope.assignedGroupsGrid.refresh()
            }
            if (!backward) {
                if ($scope.source.isAlarmGroupsEdit) {
                    var defGroupsModelArray = []
                    for (var key in $scope.assigned) {
                        var defGroupModel = new DefGroupsModel()
                        defGroupModel.defId = Number(key)
                        defGroupModel.groups = []
                        defGroupModel.removedGroups = []
                        if (Array.isArray($scope.assigned[key])) {
                            $scope.assigned[key].forEach(group => {
                                defGroupModel.groups.push({ idGroup: group.id, idTransmissionType: 0 })
                            })
                        }
                        if (Array.isArray($scope.retracted[key])) {
                            $scope.retracted[key].forEach(removedGroup => {
                                defGroupModel.removedGroups.push({ idGroup: removedGroup.id, idTransmissionType: 0 })
                            })
                        }
                        if (defGroupModel.groups.length || defGroupModel.removedGroups.length) {
                            defGroupsModelArray.push(defGroupModel)
                        }
                    }
                    var currentMd5 = Md5.init(defGroupsModelArray)
                    if (this.previousSaveRequestMd5 !== currentMd5 || this.groupsSaveFailed) {
                        this.previousSaveRequestMd5 = currentMd5
                        $scope.source.onSubmit(defGroupsModelArray).then(() => {
                            stage()
                            this.groupsSaveFailed = false
                        }).catch(() => {
                            this.groupsSaveFailed = true
                        }).finally(() => {
                            $scope.source.popupTitle = $scope.popupTitle + " (" + this.popupTitleNewLength + ")"
                            $scope.isLoading = false
                        })
                    }
                    else {
                        $scope.isLoading = false
                    }
                } else {
                    $scope.source.onSubmit($scope.assigned.map(g => g.id), $scope.retracted.map(g => g.id)).then(stage).finally(() => {
                        $scope.source.popupTitle = $scope.popupTitle + " (" + this.popupTitleNewLength + ")"
                        $scope.isLoading = false
                    })
                }
            } else {
                stage()
                $scope.isLoading = false
            }
        }

        $scope.$on(EventsNames.UPDATE_DEFINITION_GROUPS, () => {
            assignedGroupsDataRequest()
        })

        $scope.$watch('[assigned, retracted]', (newValue: any, oldValues: any) => {
            var assigned = newValue[0]
            var retracted = newValue[1]

            if ($scope.source.isAlarmGroupsEdit) {
                var totalLength = 0
                for (var key in $scope.assigned) {
                    if (Array.isArray($scope.assigned[key])) {
                        totalLength = totalLength + $scope.assigned[key].length
                    }
                }
                for (var key in $scope.retracted) {
                    if (Array.isArray($scope.retracted[key])) {
                        totalLength = totalLength + $scope.retracted[key].length
                    }
                }
                $scope.noChanges = !totalLength
            }
            else {
                $scope.noChanges = !(($scope.assigned ? $scope.assigned.length : 0) + ($scope.retracted ? $scope.retracted.length : 0))
            }
        }, true)

        $scope.$watch('source.activeAlarmDef', (activeAlarmDef: any) => {
            request().then(result => {
                if ($scope.availableGroupsGrid) {
                    $scope.availableGroupsGrid.option("dataSource", new DataSource(result))
                    assignedGroupsDataRequest().then(result => {
                        $scope.assignedGroupsGrid.option("dataSource", new DataSource(result))
                        refreshGroups()
                    })
                }
            })
        })

        $scope.groups = <GroupsData>{}
        this.requestState = {}

        var assignedGroupsDataRequest = () => {
            var deferred = $q.defer<any[]>()
            if ($scope.source.isAlarmGroupsEdit && $scope.source.activeAlarmDef) {
                $scope.activeDefAssigned = []
                $scope.source.assigned.forEach(group => {
                    if (group.alarmGroupDefs) {
                        for (var i = 0; i < group.alarmGroupDefs.length; i++) {
                            if (group.alarmGroupDefs[i].idAlarmDef == $scope.source.activeAlarmDef.id) {
                                $scope.activeDefAssigned.push(group)
                                break
                            }
                        }
                    }
                })
                deferred.resolve($scope.activeDefAssigned.slice())
            }
            else {
                deferred.resolve($scope.source.assigned.slice())
            }
            return deferred.promise
        }

        var onRowPrepared = (e: any) => {
            if (e.rowType == "data") {
                if (e.data.isNew) {
                    $(e.rowElement).css('font-style', 'italic')
                }
                else if (e.data.isRemoved) {
                    $(e.rowElement).css('text-decoration', 'line-through')
                }
            }
        }

        var request = () => {
            $scope.isLoading = true
            if ($scope.source.request)
                return $scope.source.request(this.requestState)
        }

        var loadGroups = () => {
            $scope.availableGroupsGridOptions = null
            var availableGroupsQ: ng.IPromise<void> = request().then(result => {
                $timeout(() => {
                    $scope.availableGroupsGridOptions = {
                        name: null,
                        type: GridTypes.PAGINATED_SMALL,
                        buttonsOptions: {
                            enabled: true
                        },
                        ignoreKey: true,
                        dataSource: new DataSource(result),
                        allowColumnReordering: $scope.source.allowColumnReordering != null ? $scope.source.allowColumnReordering : true,
                        columns: [
                            {
                                dataField: "name",
                                caption: i18n('Popup', 'AvailableGroups'),
                                selectedFilterOperation: 'contains'
                            },
                            {
                                dataField: "id",
                                visible: false
                            }
                        ],
                        onInitialized: e => {
                            $scope.availableGroupsGrid = e.component
                        },
                        onRowDoubleClick: e => {
                            $scope.source.openGroup(e)
                            $scope.transferForwardButtonDisabled = false
                        },
                        onSelectionChanged: e => {
                            if (e.selectedRowsData.length > 0) {
                                $scope.transferForwardButtonDisabled = false
                            }
                            else {
                                $scope.transferForwardButtonDisabled = true
                            }
                        },
                        onRowPrepared: onRowPrepared
                    }
                })
            })

            $scope.assignedGroupsGridOptions = null
            var assignedGroupsQ = assignedGroupsDataRequest().then(result => {
                $timeout(() => {
                    $scope.assignedGroupsGridOptions = {
                        name: null,
                        buttonsOptions: {
                            enabled: true
                        },
                        ignoreKey: true,
                        dataSource: new DataSource(result),
                        allowColumnReordering: $scope.source.allowColumnReordering != null ? $scope.source.allowColumnReordering : true,
                        type: GridTypes.PAGINATED_SMALL,
                        columns: [
                            {
                                dataField: "name",
                                caption: i18n('Popup', 'AssignedGroups'),
                                selectedFilterOperation: 'contains'
                            }, {
                                dataField: "id",
                                visible: false
                            }
                        ],
                        onInitialized: e => {
                            $scope.assignedGroupsGrid = e.component
                        },
                        onSelectionChanged: e => {
                            if (e.selectedRowsData.length > 0) {
                                $scope.transferBackButtonDisabled = false
                            }
                            else {
                                $scope.transferBackButtonDisabled = true
                            }
                        },
                        onRowDoubleClick: e => {
                            $scope.source.openGroup(e)
                            $scope.transferBackButtonDisabled = false
                        },
                        onRowPrepared: onRowPrepared,
                    }
                })
            })

            return $q.all([availableGroupsQ, assignedGroupsDataRequest])
        }

        var transferData = (keys: any[], added: any[], removed: any[], from: Store, to: Store): JQueryPromise<any> => {
            if (!added) added = []
            if (!removed) removed = []

            var deferred = $.Deferred()
            keys.forEach(element => {
                if (!element.isRemoved) {
                    if (element.isNew) {
                        var index
                        removed.every((el, i) => {
                            if (el.id == element.id) {
                                index = i
                                return false
                            }
                            return true
                        })
                        removed.splice(index, 1)
                        from.remove(element).then(e => {
                            (<any>to).createQuery().filter('id', '=', (e as any).id).toArray()[0].isRemoved = false
                            deferred.resolve()
                        })
                    } else {
                        added.push(element)
                        var newElement = (<any>Object).assign({}, element)
                        newElement.isNew = true
                        element.isRemoved = true
                        to.insert(newElement).then((e) => {
                            deferred.resolve()
                        })
                    }
                } else {
                    deferred.reject("Can't transfer removed row")
                }
            })
            return deferred.promise()
        }

        $scope.groups.transferAvailableGroups = () => {
            var availableDataSource = $scope.availableGroupsGrid.option("dataSource")
            var currentMd5 = Md5.init(availableDataSource._store._array)
            if (this.availableGroupsMd5 !== currentMd5) {
                this.availableGroupsMd5 = currentMd5
                var assignedDataSource = $scope.assignedGroupsGrid.option("dataSource")
                var selectedGroups = $scope.availableGroupsGrid.getSelectedRowsData()
                var assigned
                var retracted
                if ($scope.source.activeAlarmDef) {
                    if (!$scope.assigned[$scope.source.activeAlarmDef.id]) {
                        $scope.assigned[$scope.source.activeAlarmDef.id] = []
                    }
                    if (!$scope.retracted[$scope.source.activeAlarmDef.id]) {
                        $scope.retracted[$scope.source.activeAlarmDef.id] = []
                    }
                    assigned = $scope.assigned[$scope.source.activeAlarmDef.id]
                    retracted = $scope.retracted[$scope.source.activeAlarmDef.id]
                }
                else {
                    assigned = $scope.assigned
                    retracted = $scope.retracted
                }
                if (assigned.length == 0 && retracted.length == 0) this.availableGroupsMd5 = ''
                transferData(selectedGroups, assigned, retracted, availableDataSource.store(), assignedDataSource.store()).then(() => {
                    $scope.availableGroupsGrid.refresh()
                    $scope.assignedGroupsGrid.refresh()
                    var assignedLength
                    if ($scope.activeDefAssigned) {
                        this.popupTitleNewLength = $scope.activeDefAssigned.length + $scope.assigned[$scope.source.activeAlarmDef.id].length - $scope.retracted[$scope.source.activeAlarmDef.id].length
                        assignedLength = $scope.activeDefAssigned.length
                    }
                    else {
                        this.popupTitleNewLength = $scope.source.assigned.length + $scope.assigned.length - $scope.retracted.length
                        assignedLength = $scope.source.assigned.length
                    }
                    $scope.source.popupTitle = $scope.popupTitle + " (" /*+ assignedLength + "/" */ + this.popupTitleNewLength + ")"
                }).fail(e => {
                    this.availableGroupsMd5 = ""
                })
                $timeout(() => {
                    $scope.availableGroupsGrid.deselectAll()
                }, 100)
            }
        }

        $scope.groups.transferAssignedGroups = () => {
            var availableDataSource = $scope.availableGroupsGrid.option("dataSource")
            var assignedDataSource = $scope.assignedGroupsGrid.option("dataSource")
            var currentMd5 = Md5.init(assignedDataSource._store._array)
            if (this.availableGroupsMd5 !== currentMd5) {
                this.availableGroupsMd5 = currentMd5
                var selectedGroups = $scope.assignedGroupsGrid.getSelectedRowsData()
                var assigned
                var retracted
                if ($scope.source.activeAlarmDef) {
                    if (!$scope.assigned[$scope.source.activeAlarmDef.id]) {
                        $scope.assigned[$scope.source.activeAlarmDef.id] = []
                    }
                    if (!$scope.retracted[$scope.source.activeAlarmDef.id]) {
                        $scope.retracted[$scope.source.activeAlarmDef.id] = []
                    }
                    assigned = $scope.assigned[$scope.source.activeAlarmDef.id]
                    retracted = $scope.retracted[$scope.source.activeAlarmDef.id]
                }
                else {
                    assigned = $scope.assigned
                    retracted = $scope.retracted
                }
                if (assigned.length == 0 && retracted.length == 0) this.availableGroupsMd5 = ''
                transferData(selectedGroups, retracted, assigned, assignedDataSource.store(), availableDataSource.store()).then(() => {
                    $scope.availableGroupsGrid.refresh()
                    $scope.assignedGroupsGrid.refresh()
                    var assignedLength
                    if ($scope.activeDefAssigned) {
                        this.popupTitleNewLength = $scope.activeDefAssigned.length + $scope.assigned[$scope.source.activeAlarmDef.id].length - $scope.retracted[$scope.source.activeAlarmDef.id].length
                        assignedLength = $scope.activeDefAssigned.length
                    }
                    else {
                        this.popupTitleNewLength = $scope.source.assigned.length + $scope.assigned.length - $scope.retracted.length
                        assignedLength = $scope.source.assigned.length
                    }
                    $scope.source.popupTitle = $scope.popupTitle + " (" /*+ assignedLength + "/" */ + this.popupTitleNewLength + ")"
                }).fail(e => {
                    this.availableGroupsMd5 = ""
                })
                $timeout(() => {
                    $scope.assignedGroupsGrid.deselectAll()
                }, 100)
            }
        }

        var submitButton: DevExpress.ui.dxButton
        $scope.submitButtonOptions = {
            text: i18n('Common', 'Apply'),
            bindingOptions: {
                disabled: 'noChanges'
            },
            onInitialized: e => {
                submitButton = e.component
            },
            onClick: () => {
                stageChanges(false)
            }
        }

        $scope.transferButtonsDisabled = true

        $scope.transferBackButtonDisabled = true
        $scope.transferForwardButtonDisabled = true

        var backTemplate: any
        var forwardTemplate: any
        if ($scope.$root['rtlState']) {
            backTemplate = TemplateHelper.getIcon(ConfigHelper.Icon.ARROW_FORWARD, userSession)
            forwardTemplate = TemplateHelper.getIcon(ConfigHelper.Icon.ARROW_BACK, userSession)
        }
        else {
            backTemplate = TemplateHelper.getIcon(ConfigHelper.Icon.ARROW_BACK, userSession)
            forwardTemplate = TemplateHelper.getIcon(ConfigHelper.Icon.ARROW_FORWARD, userSession)
        }

        $scope.transferBackButtonOptions = {
            template: backTemplate,
            onClick: $scope.groups.transferAssignedGroups,
            //disabled: $scope.transferButtonsDisabled,
            bindingOptions: {
                disabled: 'transferBackButtonDisabled'
            }
        }

        $scope.transferForwardButtonOptions = {
            template: forwardTemplate,
            onClick: $scope.groups.transferAvailableGroups,
            //disabled: $scope.transferButtonsDisabled,
            bindingOptions: {
                disabled: 'transferForwardButtonDisabled'
            }
        }

        $scope.$on(EventsNames.MASS_LOCATION_GROUPS_EDIT_SUMBIT, () => {
            stageChanges(false)
        })
    }]
}